export const getFieldSurveyLabelizedValue = (field) =>
  field.field_enum?.find((option) => option.option_value === field.field_value)?.option_label;